import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(1),
        borderTop: `1px solid ${theme.colors.gray[200]}`,
    },
    actionButton: {
        marginLeft: theme.spacing(1),
    },
}));
//# sourceMappingURL=AsyncMenuList.styles.js.map